<template src="./company-dashboard.html" lang="html"></template>

<script>
import mixins from "../../../mixins/mixins.js";
import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/chart/pie";
export default {
  mixins: [mixins],
  components: {
    ECharts,
  },
  data() {
    return {
      idCompany: null,
      confirmed: 0,
      concluded: 0,
      canceled: 0,
      waitingMatch: 0,
      employessAttended: 0,
      finishRequest: false,
      dashboardData: [],
      pie: {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: [
            "Consultas solicitadas",
            "Consultas agendadas",
            "Consultas canceladas",
            "Consultas realizadas",
            "Funcionários atendidos",
          ],
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            color: ["#FF0000", "#508cc8", "#3c6997", "#78c8be", "#fd7e14"],
            data: [
              { value: 1, name: "Consultas solicitadas" },
              { value: 2, name: "Consultas agendadas" },
              { value: 3, name: "Consultas canceladas" },
              { value: 4, name: "Consultas realizadas" },
              { value: 5, name: "Funcionários atendidos" },
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
    }
  },
  mounted: function() {
    const vm = this;
    vm.finishRequest = false;
    if (vm.testNullUndefinedEmpty(vm.$session.get("idCompany")) === false) {
      vm.idCompany = vm.$session.get("idCompany");
      vm.getDashboardData();
    }
  },
  methods: {
    getDashboardData() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "bi/company/dashboard/" + vm.idCompany ,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.dashboardData = response.data;
            vm.waitingMatch = vm.dashboardData.consultasSolicitadas;
            vm.confirmed = vm.dashboardData.consultasAgendadas;
            vm.canceled = vm.dashboardData.consultasCanceladas;
            vm.concluded = vm.dashboardData.consultasRealizadas;
            vm.employessAttended = vm.dashboardData.funcionariosAtendidos;
            vm.finishRequest = true;
            vm.updateChart();
          }
        })
        .catch(function(error) {
          console.log({error: error});
        });
    },
    updateChart() {
      var vm = this;
      vm.pie.series[0].data = [
        { value: vm.waitingMatch, name: "Consultas solicitadas" },
        { value: vm.confirmed, name: "Consultas agendadas" },
        { value: vm.canceled, name: "Consultas canceladas" },
        { value: vm.concluded, name: "Consultas realizadas" },
        { value: vm.employessAttended, name: "Funcionários atendidos" },
      ];
    },
  },
};
</script>

<style src="./company-dashboard.scss" lang="scss">
</style>